import { Box, CircularProgress } from '@mui/material';
import { sporttiaColors } from '../../theme/theme';

/**
 * Spinner de pantalla completa.
 *
 * El velo es `#f8f8f8ad` sobre la página, o sea casi blanco. El color era
 * `#DBEA7B` — un lima de Figma que ahí daba 1,22:1: el spinner estaba, pero no
 * se veía. Un trazo fino es un objeto gráfico y necesita 3:1, y de la familia
 * del lima sólo `brandText` (#4f6b00, 5,7:1) llega: el relleno de marca se
 * queda en 1,24:1 y `primary.dark` en 2,23:1.
 */
function SttFullPageSpinner() {
    return (
        <Box
            sx={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                background: '#f8f8f8ad',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CircularProgress
                sx={{
                    color: sporttiaColors.brandText,
                }}
            />
        </Box>
    );
}

export default SttFullPageSpinner;
